// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./profile/reducer"

//clients
import clients from "./clients/reducer"

//popup
import popup from "./popup/reducer"

//people
import people from "./people/reducer"

//experiences
import experiences from "./experiences/reducer"

//domains
import domains from "./domains/reducer"

// onboarding flow
import onboardingFlow from "./onboardingFlow/reducer"

// business units
import businessUnits from "./businessUnits/reducer"

// menu features
import menuFeatures from "./menuFeatures/reducer"
import BasicContent from "./menuFeatures/BasicContent/reducer"
import Bookings from "./menuFeatures/Bookings/reducer"
import CalendarEvents from "./menuFeatures/CalendarEvents/reducer"
import CommentBoard from "./menuFeatures/CommentBoard/reducer"
import CountdownClock from "./menuFeatures/CountdownClock/reducer"
import Document from "./menuFeatures/Document/reducer"
import EventInfo from "./menuFeatures/EventInfo/reducer"
import FormBuilder from "./menuFeatures/FormBuilder/reducer"
import Leaderboard from "./menuFeatures/Leaderboard/reducer"
import List from "./menuFeatures/List/reducer"
import MediaGallery from "./menuFeatures/MediaGallery/reducer"
import Places from "./menuFeatures/Places/reducer"
import Poll from "./menuFeatures/Poll/reducer"
import PrivateMessage from "./menuFeatures/PrivateMessage/reducer"
import Questionnaire from "./menuFeatures/Questionnaire/reducer"
import ReferFriend from "./menuFeatures/ReferFriend/reducer"
import Survey from "./menuFeatures/Survey/reducer"
import TriviaChallenge from "./menuFeatures/TriviaChallenge/reducer"
import WebLink from "./menuFeatures/WebLink/reducer"
import VideoCall from "./menuFeatures/VideoCall/reducer"

// communications
import Communications from "./communications/reducer"

// tags
import Tags from "./tags/reducer"

// landing screen
import LandingScreen from "./landingScreen/reducer"

// list screen
import ListScreen from "./listScreen/reducer"

// contact us screen
import ContactUsScreen from "./contactUsScreen/reducer"

// platform settings
import PlatformSettings from "./platformSettings/reducer"

// visitors
import Visitors from "./visitors/reducer"

// places
import PlacesList from "./places/reducer"

// categories
import Categories from "./categories/reducer"

// bookings
import BookingsFeature from "./bookings/reducer"

// event module
import Events from "./events/reducer"

// products and subscriptions
import ProductsAndSubscriptions from "./productsAndSubscriptions/reducer"

// site users
import SiteUsers from "./siteUsers/reducer"

// roles
import Roles from "./roles/reducer"

// permissions
import Permissions from "./permissions/reducer"

// payouts
import Payouts from "./payouts/reducer"

// codes
import codes from "./codes/reducer"

// analytics
import Analytics from "./analytics/reducer"

// downloads
import Downloads from "./downloads/reducer"

// inbox
import Inbox from "./inbox/reducer"

// AxisCare
import AxisCare from "./axiscare/reducer"

const rootReducer = {
  // public
  Layout,
  Login,
  ForgetPassword,
  Profile,
  clients,
  popup,
  people,
  experiences,
  onboardingFlow,
  menuFeatures,
  domains,
  businessUnits,
  BasicContent,
  Bookings,
  CalendarEvents,
  CommentBoard,
  CountdownClock,
  Document,
  EventInfo,
  FormBuilder,
  Leaderboard,
  List,
  MediaGallery,
  Places,
  Poll,
  PrivateMessage,
  Questionnaire,
  ReferFriend,
  Survey,
  TriviaChallenge,
  WebLink,
  Communications,
  Tags,
  LandingScreen,
  ListScreen,
  ContactUsScreen,
  PlatformSettings,
  Visitors,
  PlacesList,
  Categories,
  BookingsFeature,
  Events,
  ProductsAndSubscriptions,
  SiteUsers,
  Roles,
  Permissions,
  Payouts,
  codes,
  Analytics,
  VideoCall,
  Downloads,
  Inbox,
  AxisCare
}

export default rootReducer
